import React from 'react';

import SavedSearchesBar from 'src/common/ui/SavedSearchesBar';

import { SearchState } from '../SearchPage';
import {
  useSavedSearches,
  MAX_SAVED_SEARCHES,
} from '../hooks/useSavedSearches';

interface SavedSearchesBarProps {
  readonly onLoadSearch: (state: SearchState) => void;
}

/** Search page's saved search chips. Presentation lives in the shared bar. */
const SearchSavedSearchesBar: React.FC<SavedSearchesBarProps> = ({
  onLoadSearch,
}) => {
  const { entries, remove } = useSavedSearches();

  return (
    <SavedSearchesBar<SearchState>
      entries={entries}
      remove={remove}
      onLoadSearch={onLoadSearch}
      label="Saved Searches:"
      hint={`(max ${MAX_SAVED_SEARCHES} — oldest auto-deleted)`}
      itemTestId="saved-search"
    />
  );
};

export default SearchSavedSearchesBar;
